module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAAAXNSR0IArs4c6QAAAPlJREFUKBVj+GxgcP6zkVEQA4kApAekl4mJmTmZ4f//KUCBNGLNAKsF6gHrBWn6YWSk8snA4B5QopqQISA1ILUgPSC1jDANX42NJf/9+7cTyN/Pc+5cASMj43+YHIj+//8/4xcjowlApiMTE5M799mzz0HicANAnP8ODgJfPnzYzMDI+IiHiSmB8ezZ32BxY2PWL//+LQCaIscjIODLeODAB5A4CKAYABL4b2nJ+fnHj5VAJiuvqGgISOzz69drgNRvXg6OcMbjx7+DxGAAwwCQBNAlLJ8/fJgNdIkGWOH//zd4BQRSgTb/gWkkSIP8DAysLhAGsXFpAAAlZWHJLP7DgQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/spread@2x.png
// module id = hiqq
// module chunks = 2